export class FileOrderBy {
    public static readonly ORDER_BY = [{ name: "Date", value: "ModDate" }, { name: "File Name", value: "Name" }, { name: "Type", value: "Type" }, { name: "Uploaded By", value: "UploadedBy" }];
}